import { withStyles } from '@material-ui/core';

import Factoid from './component';
import styles from './styles';

export default withStyles(styles)(Factoid);
